import React from "react";
import { useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative z-20 w-full py-4 sm:py-6">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-3 sm:space-y-0 sm:space-x-4">
          <button
            onClick={() => navigate("/terms")}
            className="text-white/70 hover:text-white text-xs sm:text-sm font-light transition-colors duration-200"
          >
            Terms of Service
          </button>
          <span className="hidden sm:inline text-white/30">|</span>
          <button
            onClick={() => navigate("/privacy-policy")}
            className="text-white/70 hover:text-white text-xs sm:text-sm font-light transition-colors duration-200"
          >
            Privacy Policy
          </button>
          <span className="hidden sm:inline text-white/30">|</span>
          <button
            onClick={() => navigate("/copyright-removal")}
            className="text-white/70 hover:text-white text-xs sm:text-sm font-light transition-colors duration-200"
          >
            Copyright Removal
          </button>
          <span className="hidden sm:inline text-white/30">|</span>
          <button
            onClick={() => navigate("/contact")}
            className="text-white/70 hover:text-white text-xs sm:text-sm font-light transition-colors duration-200"
          >
            Contact Us
          </button>
        </div>
        <div className="text-center text-white/60 text-xs sm:text-sm font-light mt-3">
          © {currentYear} Waytora. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
